import type {
  GetRefundedCountResponse,
  GetRefundedResponse,
  GetRefundedsResponse,
  GetRefundedsSearchParams,
} from '@/types/refunded'
import type { Options } from 'ky'
import { INITIAL_PER_PAGE } from '@/utils/constant'
import { httpClient } from '@/utils/http'

export const refundedService = {
  count: (options?: Options) =>
    httpClient.get('refundeds/count', options).json<GetRefundedCountResponse>(),
  list: (params: GetRefundedsSearchParams, options?: Options) =>
    httpClient
      .get('refundeds', {
        ...options,
        searchParams: {
          ...params,
          ...((options?.searchParams ?? {}) as Record<string, unknown>),

          page: params.page ?? 1,
          per_page: INITIAL_PER_PAGE,
        },
      })
      .json<GetRefundedsResponse>(),
  detail: (id: string, options?: Options) =>
    httpClient.get(`refundeds/${id}`, options).json<GetRefundedResponse>(),
}
